import { createFileRoute } from "@tanstack/react-router";
import { SandboxesList, type SandboxesSearch } from "../../features/sandboxes/sandboxes-list";

const TABS = ["all", "running", "stopped"] as const;

export const Route = createFileRoute("/_authed/$org/$project/sandboxes/")({
  validateSearch: (s: Record<string, unknown>): SandboxesSearch => ({
    ...(TABS.includes(s.tab as never) ? { tab: s.tab as SandboxesSearch["tab"] } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
  }),
  component: SandboxesPage,
});

function SandboxesPage() {
  const { org, project } = Route.useParams();
  return <SandboxesList scope={{ org, project }} search={Route.useSearch()} />;
}
